import Poll from 'features/poll';
import { useTitle } from '../helpers';

/**
 * @page Poll
 */
const PollPage = () => {
  useTitle('Опросы');

  return (
    <div>
      <Poll />
    </div>
  );
};

export default PollPage;
